import { useState, useCallback } from 'react';

export function useConfirm() {
  const [state, setState] = useState(null);

  const ask = useCallback((message, onConfirm, onCancel) => {
    setState({ message, onConfirm, onCancel });
  }, []);

  const confirm = useCallback(() => {
    if (state?.onConfirm) state.onConfirm();
    setState(null);
  }, [state]);

  const cancel = useCallback(() => {
    if (state?.onCancel) state.onCancel();
    setState(null);
  }, [state]);

  return { pending: state, ask, confirm, cancel };
}
